export default function genererCritereRechercheNumerique() {
  return {
    nbHabitants: {
      operateur: null,
      valeur: null,
    },
    libelle: null,
    enseignePrincipale: [],
    enseigneMarque: [],
    villes: [],
    societeId: null,
    agencesId: [],
  };
}
